import apiClient from './instance';
import { AxiosResponse } from 'axios';
import { FilterConfig } from '@/types/ui';

export interface Option {
  value: string;
  label: string;
}

export interface SelectOption<T = string | number> {
  value: T;
  label: string;
}

export interface CountryOption extends Option {
  provinces?: Option[];
  states?: Option[];
}

export interface UIOptionsResponse {
  filters: FilterConfig[];
  fields: {
    country: CountryOption[];
  };
}

/**
 * Fetches UI options for a given page/module.
 * @param path - The base path for the options endpoint (e.g., 'properties').
 * @returns A promise that resolves to the UI options response.
 */
export const getUIOptionsRequest = (
  path: string,
): Promise<AxiosResponse<{ data: UIOptionsResponse }>> => {
  return apiClient.get(`/${path}/options`);
};
